export default __webpack_public_path__ + "static/media/V_sound.8446369c.mp3";